import { isDomainSplitEnabled, landingUrl } from './domainRouting';

const LOCAL_ORIGIN = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i;

function normalizeBaseUrl(url) {
  if (!url || typeof url !== 'string') {
    return '';
  }
  return url.trim().replace(/\/$/, '');
}

/**
 * Public base URL for referral links and QR codes.
 * In production domain split, referrals use the landing host (enrolanow.com).
 */
export function getPublicReferralBaseUrl() {
  if (isDomainSplitEnabled()) {
    return normalizeBaseUrl(landingUrl('/'));
  }

  const referralEnv = normalizeBaseUrl(process.env.REACT_APP_REFERRAL_BASE_URL);
  if (referralEnv) {
    return referralEnv;
  }

  const envBase = normalizeBaseUrl(process.env.REACT_APP_FRONTEND_URL);

  if (typeof window !== 'undefined') {
    const origin = normalizeBaseUrl(window.location.origin);
    if (origin && !LOCAL_ORIGIN.test(origin)) {
      return origin;
    }
    if (envBase && !LOCAL_ORIGIN.test(envBase)) {
      return envBase;
    }
    return envBase || origin;
  }

  return envBase;
}

export function mapDualProgramLinks(links) {
  const list = Array.isArray(links) ? links : [];
  const isClients = (link) =>
    link.program_type === 'clients' ||
    link.program === 'clientes' ||
    link.program === 'clients';
  const isPartners = (link) =>
    link.program_type === 'partners' ||
    link.program === 'socios' ||
    link.program === 'partners';

  let clientsLink = list.find(isClients);
  let partnersLink = list.find(isPartners);

  if (!clientsLink && list[0]) clientsLink = list[0];
  if (!partnersLink && list[1] && list[1] !== clientsLink) partnersLink = list[1];
  if (!partnersLink && list[0] && list[0] !== clientsLink) partnersLink = list[0];

  return { clientsLink, partnersLink, hasRealLinks: list.length > 0 };
}

export function referralUrlForLink(link, fallbackCode) {
  const code = link?.link_code || link?.code || fallbackCode;
  if (!code) {
    return '';
  }

  const base = getPublicReferralBaseUrl();
  if (base) {
    return `${base}/referral/${code}`;
  }

  return `/referral/${code}`;
}
